// extracted by mini-css-extract-plugin
export default {"strong":"strong__3NmsM","serif":"serif__hv5P5"};